import { getAccessToken } from '../utils/cookie.utils';

/**
 * useAccessToken Hook
 * 
 * Custom hook to retrieve the current access token from the app state.
 * - First tries window.appAccessToken global variable (set during authentication)
 * - Then uses getAccessToken() utility which checks:
 *   - Cookie (i_a_t key)
 *   - localStorage (ideoz_access_token key)
 * - Falls back to empty string for fire-and-forget operations
 * 
 * This is a utility hook used by facades to refresh user data after major operations.
 * Supports both web and plugin environments.
 * 
 * @returns The access token string, or empty string if not available
 */
export function useAccessToken(): string {
  // 1. Try to get from window global if available (set during auth)
  if (typeof window !== 'undefined' && (window as any).appAccessToken) {
    return (window as any).appAccessToken as string;
  }

  // 2. Try to get from cookies and localStorage using utility
  const token = getAccessToken();
  if (token) {
    return token;
  }

  // 3. Fallback: empty string for fire-and-forget refresh
  return '';
}
